import styled from 'styled-components';

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  margin-bottom: 20px;

  div {
    display: flex;
    align-items: center;
  }
`;

export default Title;
